import { Card, CardBody, Col } from 'reactstrap'
import { borderColorData, borderColorDetail } from '../../../../Data/Ui-Kits/HelperClasses/HelperClassesData'
import { BorderColor } from '../../../../utils/Constant'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const BorderColorCart = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={BorderColor} span={borderColorDetail} />
        <CardBody>
          <div className="gradient-border">
            <div className="helper-common-box">
              <div className="helper-box b-primary border fill-wrapper"> </div>.b-primary
            </div>
            {borderColorData.map((item, index) => (
              <div className="helper-common-box" key={index}>
                <div className={`helper-box ${item} border fill-wrapper`}> </div>.{item}
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default BorderColorCart